export type TextSelection = { start: number; end: number };

export function insertAtSelection(value: string, text: string, selection: TextSelection) {
  const start = Math.max(0, Math.min(value.length, selection.start));
  const end = Math.max(start, Math.min(value.length, selection.end));
  return {
    value: `${value.slice(0, start)}${text}${value.slice(end)}`,
    cursor: start + text.length,
  };
}

export function moveSelectionAfterEdit(
  previous: string,
  next: string,
  selection: TextSelection,
): TextSelection {
  let changeStart = 0;
  while (
    changeStart < previous.length &&
    changeStart < next.length &&
    previous[changeStart] === next[changeStart]
  ) {
    changeStart += 1;
  }
  let previousEnd = previous.length;
  let nextEnd = next.length;
  while (
    previousEnd > changeStart &&
    nextEnd > changeStart &&
    previous[previousEnd - 1] === next[nextEnd - 1]
  ) {
    previousEnd -= 1;
    nextEnd -= 1;
  }
  const moveOffset = (offset: number) => {
    if (offset < changeStart) return offset;
    if (offset >= previousEnd) return offset + nextEnd - previousEnd;
    return nextEnd;
  };
  return { start: moveOffset(selection.start), end: moveOffset(selection.end) };
}
